<template>
	<section ref="qrPanel" class="qr-section">
		<client-only>
			<div class="qr-panel">
				<div class="row">
					<form class="booking bookForm">
						<div class="columns column4">
							<date-picker
								v-model:value="state.arrival"
								:clearable="false"
								:disabled-date="disableArrivalDates"
								format="DD-MM-YYYY"
								:placeholder="$t('checkIn')"
								:lang="datepickerLang"
								@pick="pickArrival"
							/>
							<div class="border" />
						</div>
						<div class="columns column4">
							<date-picker
								v-model:value="state.departure"
								:open="state.openDeparture"
								:disabled-date="disableDepartureDates"
								format="DD-MM-YYYY"
								:placeholder="$t('checkOut')"
								:default-value="state.pickedArrivalDate ?? new Date()"
								:lang="datepickerLang"
								@open="state.openDeparture = true"
								@close="state.openDeparture = false"
							/>
						</div>
						<div class="columns column4">
							<book-button
								class="button book-now cta qr"
								:arrival="state.arrival"
								:departure="state.departure"
							>
								{{ bookingForm.availability }}
							</book-button>
						</div>
					</form>
				</div>
			</div>
		</client-only>
	</section>
</template>

<script setup>
import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';
import datePickerTranslations from '~/i18n/datePicker.ts';

const { locale } = useI18n();

defineProps({
	bookingForm: { type: Object, default: () => ({}) },
});

const state = reactive({
	arrival: null,
	departure: null,
	openDeparture: false,
	pickedArrivalDate: null,
});

const qrPanel = ref(null);

const datepickerLang = computed(() => datePickerTranslations[locale] ?? datePickerTranslations.en);

const pickArrival = (date) => {
	state.departure = null;
	state.pickedArrivalDate = date;
	state.openDeparture = true;
};

const disableArrivalDates = (date) => {
	const today = new Date();

	return date < today.setDate(today.getDate() - 1);
};

const disableDepartureDates = (date) => {
	if (!state.pickedArrivalDate) {
		return disableArrivalDates(date);
	}

	return date <= state.pickedArrivalDate;
};

onMounted(() => {
	qrPanel.value.classList.add('mounted');
});
</script>

<style>
.mx-input {
	margin: 0 !important;
	width: 100% !important;
	padding: 15px 50px 15px 15px !important;
	height: 50px !important;
	border: none !important;
	box-shadow: none !important;
	outline: none !important;
	background: none !important;
}

.mx-icon-calendar {
	color: var(--cta-color);
	right: 18px !important;
}
</style>

<style lang="scss" scoped>
.qr-section {
	text-align: center;
	margin: 0 auto;
	position: absolute;
	bottom: 100px;
	left: 0;
	right: 0;
	padding: 0;
	float: left;
	width: 100%;
	max-width: 720px;
	z-index: 10;

	::placeholder {
		color: var(--nav-color);
		text-transform: uppercase;
	}
}

.qr-panel {
	float: none;
	padding: 0;
	width: 100%;
	margin: 0 auto;
	display: inline-block;
	position: relative;
	z-index: 2;
	text-align: center;

	.row {
		width: 100%;
		background: rgb(255 255 255 / 95%);
		padding: 10px;

		.column12 {
			text-align: left;
		}

		span {
			margin: 0 5px 0 0;
		}
	}

	.columns {
		padding: 0;
		width: 30%;

		&:last-child {
			width: 40%;
		}

		&:first-child {
			display: flex;
			flex-flow: row nowrap;
			justify-content: space-between;
		}

		.border {
			background: var(--dark-background-color);
			height: 28px;
			width: 1px;
			margin: 11px 0 0;
		}
	}

	form {
		width: 100%;
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		justify-content: space-between;
	}
}

.qr-panel input,
.qr-panel select {
	margin: 0 !important;
	width: 100% !important;
	padding: 15px 40px 15px 15px !important;
	height: 50px !important;
	border: none;
	outline: none;
	box-shadow: none;
}

.qr-panel .button {
	padding: 14px 30px !important;
	text-transform: uppercase;
	border: none !important;
	vertical-align: top;
	width: 100%;
}
</style>
